const NASTALIQ_FONT = "'Noto Nastaliq Urdu'";
const URDU_FONT_FALLBACK = `${NASTALIQ_FONT}, 'Urdu Typesetting', sans-serif`;
const GENERIC_FONT_FAMILY = /\b(sans-serif|serif|monospace|cursive|fantasy|system-ui|ui-sans-serif|ui-serif|emoji|math|fangsong)\b/i;

export function urduLineHeight(lineHeight?: string): string {
  if (typeof document !== 'undefined' && document.documentElement.classList.contains('lang-ur')) {
    return '2.4';
  }
  return lineHeight || 'normal';
}

export function withUrduFontFallback(fontFamily?: string): string {
  if (!fontFamily || fontFamily === 'inherit') {
    return fontFamily === 'inherit' ? 'inherit' : `'Questrial', ${URDU_FONT_FALLBACK}`;
  }
  if (fontFamily.includes('Noto Nastaliq Urdu')) {
    return fontFamily;
  }

  const genericMatch = fontFamily.match(GENERIC_FONT_FAMILY);
  if (genericMatch && genericMatch.index !== undefined) {
    const namedFonts = fontFamily.slice(0, genericMatch.index).replace(/,\s*$/, '');
    const genericFonts = fontFamily.slice(genericMatch.index);
    return namedFonts
      ? `${namedFonts}, ${NASTALIQ_FONT}, ${genericFonts}`
      : `${NASTALIQ_FONT}, ${genericFonts}`;
  }

  return `${fontFamily}, ${URDU_FONT_FALLBACK}`;
}

export function buildPublicExperienceStyles(type: string, style: any, active: boolean = false): string {
  if (!style) return '';
  if(type === 'text' || type === 'title' || type === 'description' || type === 'date') {
    return `
      color: ${!active ? style.color : '#FFFFFF'};
      font-size: ${style.fontSize};
      font-weight: ${style.fontWeight};
      font-family: ${withUrduFontFallback(style.fontFamily)} !important;
      text-align: ${style.textAlign};
      line-height: ${urduLineHeight(style.lineHeight)};
      background-color: ${active ? style.color : ''};
    `;
  }
  if(type === 'attribute') {
    return `
      color: ${style.color};
      font-size: ${style.fontSize};
      font-weight: ${style.fontWeight};
      font-family: ${withUrduFontFallback(style.fontFamily)} !important;
      text-align: ${style.textAlign};
      line-height: ${urduLineHeight(style.lineHeight)};
      background-color: ${style.backgroundColor};
    `;
  }
  if(type === 'option') {
    return `
      color: ${style.color};
      font-size: ${style.fontSize};
      font-weight: ${style.fontWeight};
      font-family: ${withUrduFontFallback(style.fontFamily)} !important;
      line-height: ${urduLineHeight(style.lineHeight)};
      background-color: ${style.backgroundColor};
    `;
  }
  if(type === 'button') {
    return `
      color: ${style.color};
      background-color: ${style.backgroundColor};
      font-size: ${style.fontSize};
      font-weight: ${style.fontWeight};
      font-family: ${withUrduFontFallback(style.fontFamily)} !important;
    `;
  }
  if(type === 'image') {
    return `
      background-color: ${style.backgroundColor};
    `;
  }
  if(type === 'icon') {
    return `
      color: ${style.color} !important;
      font-size: ${style.fontSize} !important;
    `;
  }
  if(type === 'locationLink') {
    return `
      color: ${style.color};
      font-size: ${style.fontSize};
      font-weight: ${style.fontWeight};
      text-decoration: ${style.textDecoration} !important;
    `;
  }
  return ``;
}
